
import Loadable from 'react-loadable';
import Spinner from '../../components/spinner';


export default Loadable({
  loader: () => import(/* webpackChunkName: "TripEdit"*/'./trip-edit'),
  loading: Spinner
});
